export const ADDRESS_LIST_KEY = 'address-list';
export const CONTACT_GROUPS_KEY = 'contact-groups';

export const ADDRESS_SESSION_KEYS: string[] = [ADDRESS_LIST_KEY, CONTACT_GROUPS_KEY];
